import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-edit',
	path: '/secure/project/EditProjectRole([!%]?[\\w]*).jspa',
};
